import React from "react";
import defaultImage from "../../images/default-avatar.jpg";
import { CaButton } from "src/admin-panel";
import classNames from "classnames";
import { Cancel2Icon } from "@/icons/primary-icons-new";

export type ChatProductProps = {
  pictureUrl?: string;
  title: string;
  price: string;
  onClick?: () => void;
  btnText: string;
  className?: string;
  onHide?: () => void;
};

export function ChatProduct({
  pictureUrl,
  title,
  price,
  onClick,
  btnText,
  className,
  onHide,
}: ChatProductProps) {
  return (
    <div
      className={classNames(
        "flex justify-between rounded-lg bg-white gap-2 sm:gap-6 p-5 sm:p-8 relative",
        className,
      )}
    >
      {onHide && (
        <div className='absolute right-5 top-4 cursor-pointer' onClick={onHide}>
          <Cancel2Icon style={{ width: 20 }} />
        </div>
      )}
      <div className='flex gap-2 sm:gap-6'>
        <div
          className='w-11 h-11 min-w-11 sm:w-24 sm:h-24 sm:min-w-24'
          style={{
            background: `url('${pictureUrl || defaultImage}') no-repeat`,
            backgroundSize: "cover",
            borderRadius: "6px",
          }}
        />
        <div className='flex flex-col justify-center font-sans-serif'>
          <div className=' font-semibold text-xs sm:text-xl'>{title}</div>
          {price && (
            <div className='md-mt-4 text-xs sm:text-2xl text-orange font-bold'>
              {price === "0.00" ? "FREE" : `$${price}`}
            </div>
          )}
        </div>
      </div>
      <div className='flex items-center'>
        <CaButton
          className='sm:hidden'
          size='small'
          intent='purple'
          onClick={() => onClick && onClick()}
        >
          {btnText}
        </CaButton>
        <CaButton
          className='hidden sm:block'
          size='xlarge'
          intent='purple'
          onClick={() => onClick && onClick()}
        >
          {btnText}
        </CaButton>
      </div>
    </div>
  );
}
